import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromSchoolReducer from '../reducers/school.reducer';

export const selectState = createFeatureSelector<fromSchoolReducer.State>(
  fromSchoolReducer.featureKey
);

export const getSchoolContent = createSelector(selectState, (state) => state.schoolContent);
export const getSchoolSettings = createSelector(selectState, (state) => state.schoolSettings);
export const getSchoolYear = createSelector(selectState, (state) => state.schoolYear);
export const getSchoolYearTerms = createSelector(selectState, (state) => state.schoolYearTerms);
export const getSchoolYearPeriods = createSelector(selectState, (state) => state.schoolYearPeriods);
export const getSchoolYearEvents = createSelector(selectState, (state) => state.schoolYearEvents);
export const getFormPrograms = createSelector(selectState, (state) => state.formPrograms);
export const getProfessors = createSelector(selectState, (state) => state.professors);